import styled from "styled-components";

export const SipmlePaginationContainer = styled("div")`
  width: auto;
  text-align: right;
  padding: 2px;
  margin-left: 70vh;
  border: none;
`;

export const Pagination = styled("div")`
  margin: 20px 25px;
`;

export const TotalCountPage = styled("span")`
  color: COLORS.primary;
  font-size: 12pt;
`;

export const FormInputPage = styled("form")`
  display: inline;
`;

export const ActivePageInput = styled("input")`
  width: ${(props) => props.width};
  padding: 8px 14px;
  border-radius: 4px;
  border: 2px solid #e6e6e6;
  font-size: 12pt;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000;
  background-color: #fff;
  &:focus {
    outline: none;
  }
`;

export const TextSeparator = styled("span")`
  color: #000;
  font-size: 12pt;
  margin: 0px 10px;
`;

export const PreviousPage = styled("span")`
  left: 0.25em;
  margin: 0px 10px;
  transform: rotate(-135deg);
  color: #399ebf;
  &:before {
    border-style: solid;
    border-width: 0.2em 0.2em 0 0;
    content: "";
    display: inline-block;
    height: 0.5em;
    left: 0.15em;
    position: relative;
    top: 0.9em;
    transform: rotate(225deg);
    vertical-align: top;
    width: 0.5em;
  }
  cursor: pointer;
`;

export const NextPage = styled("span")`
  left: 0.25em;
  margin: 0px 10px;
  transform: rotate(-135deg);
  color: #399ebf;
  &:before {
    border-style: solid;
    border-width: 0.2em 0.2em 0 0;
    content: "";
    display: inline-block;
    height: 0.5em;
    left: 0.15em;
    position: relative;
    top: 0.9em;
    transform: rotate(45deg);
    vertical-align: top;
    width: 0.5em;
  }
  cursor: pointer;
`;

export const StatusHistory = styled("div")`
  color: white;
  font-size: 12px;
  margin: auto;
  align-items: center;
  background-color: ${(props) => props.color};
  padding: 3px;
  border-radius: 17px;
  display: flex;
  justify-content: center;
  min-width: 25%;
  margin-right: 5px;
`;

export const EmptyList = styled("div")`
  width: 100%;
  height: 100%;
  padding: 20px;
  margin: auto;
  justify-content: center;
`;

export const DataPerPageContainer = styled("div")`
  background-color: white;
  border-radius: 4px;
  border: 2px solid #e6e6e6;
  display: flex;
  align-items: center;
  padding-left: 5px;
  height: 33px;
`;

export const ContainerElements = styled("div")`
  width: auto;
  display: flex;
  align-items: center;
  margin: 10px 0px 5px;
`;
